/*
Replace
course with your resource Name :) Take care about different writings!
/!\ Course course Courses courses /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const courseSlice = createSlice({
  name: "courses",
  initialState: { ...defaultInitialState },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: defaultShowSuccess,
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: defaultAddToDictionary,
  },
});

export const {
  list: listCourses,
  show: showCourse,
  create: createCourse,
  update: updateCourse,
} = courseSlice.actions;

export const actions = courseSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const courses = (state) =>
  state.courses.idsList.map((id) => state.courses.dictionary[id]);
export const course = (state) =>
  state.courses.showId && state.courses.dictionary[state.courses.showId];
export const courseAttributes = (state) => course(state)?.attributes;
export const courseRelationships = (state) => course(state)?.relationships;
export const courseId = (state) => state.courses.showId;

export const getCourse = createSelector(
  (state) => state.courses.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getCourseAttributes = createSelector(
  (state) => state.courses.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getCourseRelationships = createSelector(
  (state) => state.courses.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getCourses = createSelector(
  (state) => state.courses.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export default courseSlice.reducer;
